export default __webpack_public_path__ + "static/media/lavrus-site.4f49fe58.png";